module.exports = __webpack_public_path__ + "img/code.76768edf.jpg";